module.exports = __webpack_public_path__ + "img/back.a9e44a90.svg";